import * as AspectRatioPrimitive from '@radix-ui/react-aspect-ratio';
import { styled } from '../../system';
export const AspectRatio = styled(AspectRatioPrimitive.Root, {});
AspectRatio.displayName = 'AspectRatio';
